//
// GraphDescription.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var GraphDescription = {
    NONE:0,
    BAND_PLOT:1,
    BAR_CHART:2,
    BAR_LINE_CHART:3,
    BLOCK_PLOT:4,
    BOX_PLOT:5,
    BUBBLE_PLOT:6,
    BUBBLE_CHANGE_PLOT:7,
    BUTTERFLY_CHART:8,
    BUTTON_BAR:9,
    COMPARE_TIME_SERIES:10,
    CONTOUR_PLOT:11,
    CORRELATION_MATRIX:12,
    DECISION_TREE:13,
    DOT_PLOT:14,
    DROP_DOWN_LIST:15,
    DUAL_AXIS_BAR_CHART:16,
    DUAL_AXIS_LINE_CHART:17,
    DUAL_AXIS_TIME_SERIES_PLOT:18,
    ELLIPSE_PARM:19,
    FRINGE_PLOT:20,
    GAUGE:21,
    GEO_BUBBLE:22,
    GEO_CLUSTER:23,
    GEO_CONTOUR:24,
    GEO_LINE:25,
    GEO_NETWORK:26,
    GEO_PIE:27,
    GEO_REGION:28,
    GEO_SCATTER:29,
    HEAT_BOX:30,
    HEAT_MAP:31,
    HIGH_LOW_PLOT:32,
    HISTOGRAM_PARM:33,
    HISTOGRAM:34,
    ICICLE_PLOT:35,
    KEY_VALUE:36,
    KPI_CHART:37,
    LINE_CHART:38,
    LINEAGE_DIAGRAM:39,
    LIST:40,
    MAP:41,
    MAP_REGION:42,
    MAP_LINE_LAYER:43,
    MIXED_CHART:44,
    NEEDLE_PLOT:45,
    NETWORK_DIAGRAM:46,
    NETWORK_PLOT:47,
    NODE_LINK_DIAGRAM:48,
    NUMERIC_SERIES_PLOT:49,
    PARALLEL_COORDINATES_PLOT:50,
    PFD:51,
    PIE_CHART:52,
    SANKEY_DIAGRAM:53,
    SCATTER_PLOT:54,
    SCHEDULE_CHART:55,
    SERIES_PLOT:56,
    SLIDER:57,
    STEP_PLOT:58,
    TIME_SERIES_PLOT:59,
    TARGET_BAR_CHART:60,
    TEXT_INPUT:61,
    TEXT_PLOT:62,
    TREE_DIAGRAM:63,
    TREE_MAP:64,
    VECTOR_PLOT:65,
    WATERFALL_CHART:66,
    WORD_CLOUD:67,
    POLYGON_PLOT:68,
    FORECAST_PLOT:69,
    OVERLAY_DATA_INSET:70,
    MOSAIC_PLOT:71
};
export default GraphDescription;
